import api from "./api";

function toFormData(file, mapping = null) {
  const formData = new FormData();
  formData.append("bestand", file);
  if (mapping) {
    formData.append("mapping", JSON.stringify(mapping));
  }
  return formData;
}

export async function previewProjectImportPackage(file) {
  const response = await api.post("/projects/import-jobs/preview", toFormData(file), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response?.data || {};
}

export async function startProjectImportJob(file, mapping = null) {
  const response = await api.post("/projects/import-jobs", toFormData(file, mapping), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response?.data?.job || null;
}

export async function getProjectImportJob(jobId) {
  const response = await api.get(`/projects/import-jobs/${jobId}`);
  return response?.data?.job || null;
}

export async function listProjectImportJobs(limit = 10) {
  const response = await api.get("/projects/import-jobs", { params: { limit } });
  return Array.isArray(response?.data?.jobs) ? response.data.jobs : [];
}
